import React, { Component } from "react";
import '../css/Login2.scss'
import logo from '../assets/img/Baka.png';
import Cookies from 'universal-cookie'
import Swal from 'sweetalert2'

const cookies = new Cookies();

const users = [
  { name: 'Jannete', pass: 'narom85' },
  { name: 'Elisa',   pass: 'Elisa1234' },
  { name: 'Irving',  pass: 'C@leras' },
];

class Login extends Component {
  state = {
    username: '',
    password: '',
  };

  sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }

  handleChange = e => {
    this.setState({ username: e.target.value });
  };

  handleChangePass = e => {
    this.setState({ password: e.target.value });
  };

  iniciarSesion = async () => {
    const result = users.find(
      x => x.name === this.state.username && x.pass === this.state.password
    );

    if (!result) {
      Swal.fire({
        icon: 'error',
        title: 'Credenciales incorrectas',
        text: 'Usuario y/o contraseña incorrectos.',
        confirmButtonColor: '#2b6cb0',
      });
      return;
    }

    await Swal.fire({
      icon: 'success',
      title: `¡Bienvenido, ${result.name}!`,
      showConfirmButton: false,
      timer: 1400,
      timerProgressBar: true,
    });

    cookies.set('id', 1, { path: '/' });
    cookies.set('nombre', result.name, { path: '/' });
    cookies.set('username', result.name, { path: '/' });

    window.location.href = './menu';
  };

  componentDidMount() {
    if (cookies.get('username')) {
      window.location.href = './menu';
    }
  }

  render() {
    return (
      <div className="login-page">
      <div className="grid align__item">
        <div className="register">
          <img src={logo} width={220} height={130} alt="Baka logo" />
          <h3>Iniciar sesión</h3>

          <form className="form" onSubmit={e => { e.preventDefault(); this.iniciarSesion(); }}>
            <div className="form__field">
              <input
                type="text"
                value={this.state.username}
                onChange={this.handleChange}
                placeholder="Usuario"
                autoComplete="username"
              />
            </div>

            <div className="form__field">
              <input
                type="password"
                value={this.state.password}
                onChange={this.handleChangePass}
                placeholder="Contraseña"
                autoComplete="current-password"
              />
            </div>

            <div className="form__field">
              <input type="submit" value="Iniciar sesión" />
            </div>
          </form>
        </div>
      </div>
      </div>
    );
  }
}

export default Login;
